module.exports = __webpack_public_path__ + "img/69.bd0b8fbf.png";